// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QDvYi","label":"styles_label__OaFR-","textarea":"styles_textarea__N-Hwj"};